import { useEffect } from 'react'

const Hubspot = () => {
  useEffect(
    () => () => {
      window.HubSpotConversations.clear({ resetWidget: true })
    },
    [],
  )

  useEffect(() => {
    // This is a workaround for HubSpot being amazing. This stops hubspot from adding the tracking script to the page.
    // Which in turns stops hubspot from capturing all form inputs and trying to create users and send messages to ops spam folder
    const hubspotFormSubmissionBypass = document.createElement('span')
    hubspotFormSubmissionBypass.id = `CollectedForms-${process.env.REACT_APP_HUBSPOT_APP_ID}`
    document.body.appendChild(hubspotFormSubmissionBypass)
    const script = document.createElement('script')
    script.src = `//js-na1.hs-scripts.com/${process.env.REACT_APP_HUBSPOT_APP_ID}.js`
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(hubspotFormSubmissionBypass)
      document.body.removeChild(script)
      window.hsConversationsOnReady = []
    }
  }, [])

  return null
}

export default Hubspot
